import { APP_URL } from './seo';

const BASE_URL = APP_URL || 'https://active-shape.com';

const organization = {
  '@type': 'Organization',
  name: 'Active Shape',
  url: BASE_URL,
  logo: `${BASE_URL}/og-image.png`,
  sameAs: [],
};

export const softwareApplicationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Active Shape',
  applicationCategory: 'HealthApplication',
  operatingSystem: 'Web, iOS, Android',
  description:
    'Active Shape is an AI-powered nutrition and fitness app that provides personalized nutrition plans, calorie and macro tracking, an AI food scanner, fasting tracking, and daily AI health insights tailored to your goals.',
  url: BASE_URL,
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
    description: 'Free plan available. Premium subscription unlocks full AI-powered features.',
  },
  author: organization,
});

export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  ...organization,
});

export const faqPageSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
});

export const articleSchema = (post, slug) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: post.title,
  description: post.excerpt || '',
  image: post.coverImageUrl || `${BASE_URL}/og-image.png`,
  author: organization,
  publisher: organization,
  datePublished: post.createdAt,
  dateModified: post.updatedAt || post.createdAt,
  url: `${BASE_URL}/blog/${slug}`,
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

// Hardcoded FAQs for the landing page JSON-LD (mirrors the most common product questions).
// Keep in sync with the in-app FAQ content served by the backend.
export const LANDING_PAGE_FAQS = [
  {
    question: 'What is Active Shape?',
    answer:
      'Active Shape is an AI-powered nutrition and fitness web and mobile app. It creates personalized nutrition plans with daily macro targets and meal timing, tracks calories and macros, includes an AI food scanner, and provides daily AI health insights, all tailored to your individual goals.',
  },
  {
    question: 'How does Active Shape create personalized plans?',
    answer:
      'Active Shape uses GPT-4 to analyze your health profile, dietary preferences, fitness goals, and activity level. It generates a personalized plan with daily macro targets, meal timing windows, hydration goals, activity recommendations, and fasting guidance. Plans can be regenerated as your goals change.',
  },
  {
    question: 'Is Active Shape available on mobile?',
    answer: 'Yes. Active Shape is available as a web app and as a native mobile app for iOS and Android.',
  },
  {
    question: 'Does Active Shape have a free plan?',
    answer:
      'Yes. Active Shape offers a free plan with core tracking features. Premium plans unlock the AI food scanner, AI-generated personalized plans, daily AI insights, and more.',
  },
  {
    question: 'Can I track calories and macros with Active Shape?',
    answer:
      'Yes. Active Shape includes comprehensive calorie and macro tracking. You can log meals manually, scan food with the AI food scanner, or log from a library of over 5,000 recipes.',
  },
  {
    question: 'Does Active Shape support intermittent fasting?',
    answer:
      'Yes. Active Shape has a built-in intermittent fasting tracker with a timer, fasting stage visualization, session logging, stats, and a calendar heatmap to monitor your fasting history.',
  },
];
